import { useAuth } from "@/context/AuthContext";
import { LogoManager } from "@/components/LogoManager";

export default function Organization() {
  const { user, checkAuth } = useAuth();
  const tenantId = user?.tenant_id;

  return (
    <div className="space-y-6" data-testid="organization-page">
      <div className="bg-card border border-border rounded-md p-5">
        <h3 className="text-sm uppercase tracking-wider text-muted-foreground font-medium mb-1">Organization Logo</h3>
        <p className="text-sm text-muted-foreground mb-5">{user?.tenant?.name}</p>
        {tenantId ? (
          <LogoManager tenantId={tenantId} hasLogo={!!user?.tenant?.logo_path} onChange={checkAuth} testId="org-logo-manager" />
        ) : (
          <p className="text-sm text-muted-foreground">No organization assigned.</p>
        )}
      </div>
    </div>
  );
}
